import Form from './components/form_controller';
export default class extends Form {
  dropdownIds = ['locations', 'per_page'];
  static targets = ['form', 'statusBox', 'statusInput', 'sortInput', 'sortDirectionInput'];

  activeClass = 'active';

  searchFilterTimeout = 750;

  connect() {
    const initialStatus = this.getInitialStatus();
    this.setActiveStatus(initialStatus);

    if (this.hasStatusInputTarget) {
      this.statusInputTarget.value = initialStatus;
    }

    this.sort = this.sort.bind(this);
    this.formTarget.addEventListener('click', this.sort, true);
  }

  disconnect() {
    this.formTarget.removeEventListener('click', this.sort, true);
  }

  sort(e) {
    const header = e.target.closest('.tabulator-col');

    if (!header || !this.formTarget.contains(header)) return;

    const sortFields = {
      order_id: 'id',
      pick_up_date_time: 'requested_at',
      location: 'location',
      design_item_name: 'product_name',
      price: 'price',
      name: 'customer_name',
    };

    const sort = sortFields[header.getAttribute('tabulator-field')];

    if (!sort) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (!this.hasSortInputTarget || !this.hasSortDirectionInputTarget) return;

    const sortInput = this.sortInputTarget;
    const directionInput = this.sortDirectionInputTarget;

    const currentSort = sortInput.value;
    const currentDirection = directionInput.value;

    const direction = currentSort === sort && currentDirection === 'asc' ? 'desc' : 'asc';

    sortInput.value = sort;
    directionInput.value = direction;

    this.sendFilterRequest();
  }

  setActiveStatus(initialStatus) {
    this.activeBox = this.statusBoxTargets.find((box) => {
      return box.dataset.status === initialStatus;
    });

    if (this.activeBox) {
      this.activeBox.classList.add(this.activeClass);
    }
  }

  getURLParameter(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  getInitialStatus() {
    return this.getURLParameter('filters[status]') || 'total';
  }

  toggleStatusBox(e) {
    this.activeBox = e.currentTarget;
    const status = this.activeBox.dataset.status;

    this.statusInputTarget.value = status;
    this.sendFilterRequest();

    this.statusBoxTargets.forEach((box) => {
      box.classList.remove(this.activeClass);
    });
    this.activeBox.classList.add(this.activeClass);
  }

  search() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const status = this.activeBox ? this.activeBox.dataset.status : 'total';
      this.statusInputTarget.value = status;
      this.sendFilterRequest();
    }, this.searchFilterTimeout);
  }
}
